import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enUS from './en_US.json';
import msMY from './ms_MY.json';
import zhCN from './zh_CN.json';
import zhHK from './zh_HK.json';

i18n.use(initReactI18next).init({
	resources: {
		en_US: { translation: enUS },
		ms_MY: { translation: msMY },
		zh_CN: { translation: zhCN },
		zh_HK: { translation: zhHK },
	},
	lng: 'en_US',
	fallbackLng: 'en_US',
	supportedLngs: ['en_US', 'ms_MY', 'zh_CN', 'zh_HK'],
	interpolation: {
		escapeValue: false,
	},
	debug: process.env.NODE_ENV === 'development',
	detection: {
		convertDetectedLanguage: (lng) => lng.replace('-', '_'), // 中划线转下划线
	},
});

export default i18n;
